import React from 'react'
import { Alert } from 'react-bootstrap';
import shortid from 'shortid';

class AppSchemaErrors extends React.Component{		
	
	render()
	{
		const content = this.props.validation.map( (entry) =>
		{
			return 	<Alert  key={shortid.generate()} bsStyle="danger" >
						<h4>Oh snap! Something went wrong.</h4>
						<pre>{JSON.stringify(entry.errors, null, 4)} </pre>
						<div>
						<h4>This is what was sent:</h4>
						<pre>{JSON.stringify(entry.entry, null, 4)} </pre>
						</div>
					</Alert>
		});
			return (
				
				<div>
				{content}
				</div>
				
			)
	}
}

export default AppSchemaErrors